const isMocked = process.env.REACT_APP_MODE === 'mocked';

export const baseURL = isMocked
  ? 'http://localhost:3000'
  : process.env.REACT_APP_API_URL ?? '';

export const tokensUrl = '/tokens';
export const documentsUrl = `${tokensUrl}/documents`;
export const documentsCompleteUrl = `${documentsUrl}/complete`;
